export class GetAdditionalAzureAppsOnboardingStatus200Response {
    'workflowId';
    'status';
    'errorMessage';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workflowId",
            "baseName": "workflowId",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "GetAdditionalAzureAppsOnboardingStatus200ResponseStatusEnum",
            "format": ""
        },
        {
            "name": "errorMessage",
            "baseName": "errorMessage",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetAdditionalAzureAppsOnboardingStatus200Response.attributeTypeMap;
    }
    constructor() {
    }
}
export var GetAdditionalAzureAppsOnboardingStatus200ResponseStatusEnum;
(function (GetAdditionalAzureAppsOnboardingStatus200ResponseStatusEnum) {
    GetAdditionalAzureAppsOnboardingStatus200ResponseStatusEnum["InProgress"] = "InProgress";
    GetAdditionalAzureAppsOnboardingStatus200ResponseStatusEnum["Completed"] = "Completed";
    GetAdditionalAzureAppsOnboardingStatus200ResponseStatusEnum["Failed"] = "Failed";
})(GetAdditionalAzureAppsOnboardingStatus200ResponseStatusEnum || (GetAdditionalAzureAppsOnboardingStatus200ResponseStatusEnum = {}));
